import React, { useEffect, useRef, useState } from 'react'
import styles from './style/perfect_slabs_section_style.module.scss'
import Typography from '../../design-system/foundations/typography/Typography'
import Tabs from '../../design-system/basics/tabs/Tabs'
import ProductCard from '../../design-system/moleculars/product-card/ProductCard'
import Carousel from '../../design-system/basics/carousel/Carousel'
import Properties from '../properties/Properties'
import Translation from '../../global/Translation'
import PnSpinner from '../PnSpinner'

const PerfectSlabSection = (props) => {

    const GRANITE = 'Granite'
    const MARBLE = 'Marble'
    const TRAVERTINE = 'Travertine'
    const QUARTZITE = 'Quartzite'
    const ONYX = 'Onyx'
    const LIMESTONE = 'Limestone'
    const SANDSTONE = 'Sandstone'

    const fetchedProducts = useRef({})

    const [selectedStoneType, setSelectedStoneType] = useState(GRANITE)
    const [lastFetchedFamily, setLastFetchedFamily] = useState('')
    const products = []


    useEffect(() => {
        if (fetchedProducts.current[selectedStoneType] === undefined) {
            props.fetchPerfectSlabs(selectedStoneType)
        }
    }, [selectedStoneType])

    useEffect(() => {
        const family = Object.keys(props.perfectSlabs)[0]
        const products = props.perfectSlabs[family]
        if (family) {
            setLastFetchedFamily(family)
            fetchedProducts.current[family] = products
        }
    },[props.perfectSlabs])

    useEffect(() => {
        return props.updateSection && props.updateSection(props.id, products)
    }, [lastFetchedFamily])

    const updateProduct = (id, product) => {
        products[id] = product
    }

    return (
        <div className={styles['perfect-slabs']}>
            <Typography className={styles['perfect-slabs-title']} typeface="title-xl-light">
                <Translation id="find_perfect_slab" defaultMessage="FIND THE PERFECT SLAB FOR YOUR PROJECT"/>
            </Typography>
                <div className={styles['perfect-slabs-tabs']}>
                    <Tabs
                        selected={0}
                        tabs={[
                            {label: <Translation id='granite' defaultMessage={GRANITE}/>, onClick: () => setSelectedStoneType(GRANITE), gtmLabel: "slider_filter_granite"},
                            {label: <Translation id='marble' defaultMessage={MARBLE}/>, onClick: () => setSelectedStoneType(MARBLE), gtmLabel: "slider_filter_marble"},
                            {label: <Translation id='travertine' defaultMessage={TRAVERTINE}/>, onClick: () => setSelectedStoneType(TRAVERTINE), gtmLabel: "slider_filter_travertine"},
                            {label: <Translation id='quartzite' defaultMessage={QUARTZITE}/>, onClick: () => setSelectedStoneType(QUARTZITE), gtmLabel: "slider_filter_quartzite"},
                            {label: <Translation id='onyx' defaultMessage={ONYX}/>, onClick: () => setSelectedStoneType(ONYX), gtmLabel: "slider_filter_onyx"},
                            {label: <Translation id='limestone' defaultMessage={LIMESTONE}/>, onClick: () => setSelectedStoneType(LIMESTONE), gtmLabel: "slider_filter_limestone"},
                            {label: <Translation id='sandstone' defaultMessage={SANDSTONE}/>, onClick: () => setSelectedStoneType(SANDSTONE), gtmLabel: "slider_filter_sandstone"},
                        ]}
                    />
                </div>
                {props.loadingPerfectSlabs ? <PnSpinner className={`${styles['perfect-slabs-spinner']}`}/>
                    : (fetchedProducts.current && fetchedProducts.current[selectedStoneType]) ?
                        <div id={props.id} className={styles['perfect-slabs-carousel']}>
                            <Carousel key={selectedStoneType}
                                      section={'PERFECT SLABS'}
                                      items={fetchedProducts.current[selectedStoneType].map((colors, index) =>
                                            <ProductCard key={`${colors.family}-${colors.brand}-${colors.colorId}`}
                                                         colors={colors}
                                                         centerId={props.centerId}
                                                         index={index}
                                                         updateProduct={updateProduct}
                                                         list='PN-PERFECT-SLABS'
                                            />
                                      )}
                            />
                        </div>
                    :
                        <div className={styles['perfect-slabs-no-mats']}>
                            <Typography typeface="title-m-medium">
                                <Translation id="there_are_no_materials" defaultMessage="There are currently no materials available for this type of stone."/>
                            </Typography>
                            <Typography typeface="title-s-regular">
                                <Translation id="try_select_diferent_material" defaultMessage="Try selecting a different material from the tabs above."/>
                            </Typography>
                        </div>
                }
                <Properties family={selectedStoneType} intl={props.intl} languageDir={props.languageDir} />
        </div>

    )
};

export default PerfectSlabSection;